/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Sync_LinkedInputs */

const cs_builder_sync_linked = /** @type {(inputs: Builder_Sync_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1:1`)
};

const en_builder_sync_linked = /** @type {(inputs: Builder_Sync_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1:1`)
};

/**
* | output |
* | --- |
* | "1:1" |
*
* @param {Builder_Sync_LinkedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_sync_linked = /** @type {((inputs?: Builder_Sync_LinkedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Sync_LinkedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_sync_linked(inputs)
	return cs_builder_sync_linked(inputs)
});